import cx from 'classnames'
import { useRadioGroupState } from '@react-stately/radio'
import { useRadioGroup } from '@react-aria/radio'
import { RadioContext } from './RadioContext'

import { RadioGroupProps } from './Types'

const RadioGroup = (props: RadioGroupProps) => {
  const { children, label, className } = props
  const state = useRadioGroupState(props)
  const { radioGroupProps, labelProps } = useRadioGroup(props, state)

  return (
    <div {...radioGroupProps} className={cx(className, 'notranslate')}>
      {label && <span {...labelProps}>{label}</span>}
      <RadioContext.Provider value={state}>{children}</RadioContext.Provider>
    </div>
  )
}

export { RadioGroup }
